
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { DocumentProps } from "@/hooks/admin/identity-docs/useSubmittedDocuments";

interface UseDocumentViewHandlerProps {
  document: DocumentProps;
}

export function useDocumentViewHandler({ document }: UseDocumentViewHandlerProps) {
  const [loading, setLoading] = useState(false);
  const [documentUrl, setDocumentUrl] = useState<string | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);

  const handleViewDocument = async () => {
    try {
      setLoading(true);
      setLoadError(null);
      console.log('Attempting to fetch document with path:', document.file_url);
      
      const { data, error } = await supabase.storage
        .from('identity_docs')
        .createSignedUrl(document.file_url, 60);

      if (error) {
        throw new Error(`Error generating signed URL: ${error.message}`);
      }

      if (!data?.signedUrl) {
        throw new Error('No signed URL returned from Supabase');
      }

      setDocumentUrl(data.signedUrl);
      return data.signedUrl;
    } catch (error) {
      console.error('Error fetching document URL:', error);
      const errorMessage = error instanceof Error ? error.message : 'Failed to load document';
      setLoadError(errorMessage);
      toast.error('Failed to load document');
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    handleViewDocument,
    loading,
    documentUrl,
    loadError
  };
}
